import axios from 'axios'
import qs from 'qs'

const instance = axios.create({
    withCredentials: true,
    paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
    }
})

instance.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response && error.response.status === 401) {
        const loginUrl  = document.location.origin + document.location.pathname +
            '#/login?redirect=' + encodeURIComponent(document.location.href)
        setTimeout(()=>{
            document.location.replace(loginUrl)
        },100)
    }
    return Promise.reject(error)
})

export default instance
